import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { valToPercent } from '../../../helpers/value'
import classes from './index.module.scss'

export const ScoreRangeTooltip = ({ item }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const formatPercent = (val, number) =>
    valToPercent(val, locale, false, false, number)

  return (
    <Element className={classes.scoreRangeTooltip} style={{ color: '#ECECEC' }}>
      <Element
        className={classes.title}
        style={{ color: '#FFFFFF', borderColor: '#3F4145' }}
      >
        {item.scoreRangeName}
      </Element>

      <table>
        <tbody>
          <tr>
            <td>
              <Translate value="companySummary.score.RISK_SCORE" />
            </td>
            <td className="pl3">
              {item.scoreRange_Min
                ? `${item.scoreRange_Min} - ${item.scoreRange_Max}`
                : 0}
            </td>
          </tr>
          <tr>
            <td>
              <Translate value="companySummary.score.FORECAST_PROBABILITY_12M" />
            </td>
            <td className="pl3">
              {item.minPD === item.maxPD
                ? formatPercent(item.minPD, 2)
                : `${formatPercent(item.minPD, 2)} - ${formatPercent(
                    item.maxPD,
                    2,
                  )}`}
            </td>
          </tr>
        </tbody>
      </table>
    </Element>
  )
}
